// src/pages/Project/Key/configKeyFields.js
// Config Key 各雲別的固定欄位定義，新增與編輯 Modal 共用。
// 欄位名稱需與後端解密後讀取的 key 一致（見 backend/benchmarks/services/manage/key_service.py）。
// 未列在這裡的 key_name（例如 CrowdStrike）維持手動輸入 key/value 的通用模式。

export const GCP_KEY_NAME = 'GCP';
export const AWS_KEY_NAME = 'AWS';
export const AZURE_KEY_NAME = 'AZURE';

export const CONFIG_KEY_FIELDS = {
  [AWS_KEY_NAME]: [
    // 可用逗號填多個要掃描的 region，第一個為主 region
    { key: 'REGION', required: true, placeholder: 'ap-northeast-1,us-east-1' },
    { key: 'SECRET_ARN', required: true, placeholder: 'arn:aws:secretsmanager:...' },
  ],
  [AZURE_KEY_NAME]: [
    { key: 'TENANT_ID', required: true },
    { key: 'CLIENT_ID', required: true },
    { key: 'CLIENT_SECRET', required: true },
    { key: 'SUBSCRIPTION_ID', required: true },
  ],
  [GCP_KEY_NAME]: [
    { key: 'TYPE', required: true, defaultValue: 'service_account' },
    { key: 'PROJECT_ID', required: true },
    { key: 'PRIVATE_KEY_ID', required: true },
    { key: 'PRIVATE_KEY', required: true, multiline: true, placeholder: '-----BEGIN PRIVATE KEY-----' },
    { key: 'CLIENT_EMAIL', required: true },
    { key: 'CLIENT_ID', required: false },
    { key: 'AUTH_URI', required: false },
    { key: 'TOKEN_URI', required: true },
    { key: 'AUTH_PROVIDER_X509_CERT_URL', required: false },
    { key: 'CLIENT_X509_CERT_URL', required: false },
    { key: 'UNIVERSE_DOMAIN', required: false },
  ],
};

export const normalizeKeyName = (keyName) => String(keyName || '').trim().toUpperCase();

/** 取得該 key_name 的固定欄位定義；沒有預設定義時回傳 null（走手動 key/value 模式） */
export const getConfigKeyFields = (keyName) => CONFIG_KEY_FIELDS[normalizeKeyName(keyName)] || null;

export const hasFixedFields = (keyName) => Boolean(getConfigKeyFields(keyName));

/** 依 key_name 產生空白的 key/value 陣列，供新增時預先鋪好欄位 */
export const buildDefaultContents = (keyName) => {
  const fields = getConfigKeyFields(keyName);
  if (!fields) return [{ key: '', value: '' }];

  return fields.map((field) => ({
    key: field.key,
    value: field.defaultValue || '',
  }));
};

/** 把既有的 key/value 陣列對齊到固定欄位定義（補齊缺少的、丟掉不認得的） */
export const normalizeContentsToSpec = (keyName, pairs = []) => {
  const fields = getConfigKeyFields(keyName);
  if (!fields) return pairs;

  const valueByKey = {};
  (pairs || []).forEach((item) => {
    if (item?.key) valueByKey[item.key] = item.value || '';
  });

  return fields.map((field) => ({
    key: field.key,
    value: valueByKey[field.key] || field.defaultValue || '',
  }));
};

/** 把整包 GCP service account JSON 對應到固定欄位（相容大小寫 key） */
export const mapGcpJsonToArray = (parsed) => {
  const source = parsed || {};
  return CONFIG_KEY_FIELDS[GCP_KEY_NAME].map((field) => {
    let value = source[field.key.toLowerCase()];
    if (value === undefined) value = source[field.key];
    if (value === undefined || value === null) value = field.defaultValue || '';
    return { key: field.key, value: String(value) };
  });
};
